const styles = theme => ({
  noData: {
    height: 200,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  expendedArea: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  bottomRow: {
    paddingTop: 10,
  },
  filter: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginLeft: 10,
    '& > div': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginRight: 10,
      '& > div': {
        marginRight: 10,
        '&:last-child': {
          marginRight: 0,
        },
      },
    },
  },
  fullWidthFilters: {
    marginTop: '10px',
    '&:empty': {
      display: 'none',
    },
  },
  topTable: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '4px 0 0',
    '& $tableButtons button': {
      whiteSpace: 'nowrap',
    },
    '& .label-wrapper': {
      marginBottom: 0,
      padding: 0,
    },
    '&.isSearchTable': {
      width: '100%',
      margin: '4px 0 8px',
      '& .full-width-search svg': {
        fontSize: '26px',
      },
      '& .full-width-search .label-wrapper': {
        width: '100%',
        '& .MuiInputBase-root': {
          width: '100%',
        },
      },
    },
    '&.has-extra-filters': {
      marginBottom: 0,
    },
  },
  tableButtons: {
    display: 'flex',
    flexWrap: 'wrap',
    '& button': {
      whiteSpace: 'nowrap',
    },
  },
  'col-dropdown': {
    display: 'flex',
    justifyContent: 'space-between',
    '&.dropdown': {
      marginRight: '10px',
    },
  },
  searchBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    '&.full-width-search': {
      width: '100%',
    },
  },
  'search-box-item': {
    maxWidth: 220,
    justifyContent: 'flex-start',
    height: '36px',
    border: '0px',
    '& input': {
      height: '36px',
      lineHeight: '1',
      padding: '8px 26px 8px 10px',
      marginLeft: '4px',
      border: `1px solid ${`var(--gameday-borders-borderColor, ${theme.borders.borderColor})`}`,
      borderRadius: '4px',
      '&:focus': {
        borderColor: `${theme.inputField.inputBorderActive}`,
      },
    },
    '& .input-wrapper i': {
      padding: '0',
      marginRight: '6px',
    },
    '&.full-width-search': {
      maxWidth: 'none',
      width: '100%',
      height: '36px',
      fontSize: '14px',
      marginLeft: '0px',
    },
  },
  'search-box-item-large': {
    maxWidth: 400,
    width: 280,
    marginLeft: '4px',
    justifyContent: 'flex-start',
    border: '0px',
    '& input': {
      height: 'auto',
      lineHeight: '1',
      padding: '9px 34px 10px 10px',
      border: `1px solid ${`var(--gameday-borders-borderColor, ${theme.borders.borderColor})`}`,
      borderRadius: '4px',
      '&:focus': {
        borderColor: `${theme.inputField.inputBorderActive}`,
      },
    },
    '& .input-wrapper i': {
      padding: '0',
      marginRight: '6px',
    },
  },
  tableConfig: {
    padding: '3px 0',
    marginLeft: '6px',
    width: '34px',
    height: '36px',
    '&:hover': {
      cursor: 'pointer',
    },
    '& svg': {
      transform: 'rotate(90deg)',
    },
  },
  pagingWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down(760)]: {
      flexDirection: 'column-reverse',
    },
  },
  pagingItem: {
    flexBasis: 0,
    flexGrow: 1,
    '&.align-right': {
      textAlign: 'right',
      justifyContent: 'flex-end',
      [theme.breakpoints.down(760)]: {
        textAlign: 'center',
      },
    },
    [theme.breakpoints.down(760)]: {
      width: '100%',
    },
  },
  tableWrap: {
    width: '100%',
    overflowX: 'auto',
    position: 'relative',
    paddingBottom: '20px',
    backgroundImage: `
      linear-gradient(to right, ${`var(--gameday-table-tableBgColor, ${theme.table.tableBgColor})`}, ${`var(--gameday-table-tableBgColor, ${theme.table.tableBgColor})`}),
      linear-gradient(to right, ${`var(--gameday-table-tableBgColor, ${theme.table.tableBgColor})`}, ${`var(--gameday-table-tableBgColor, ${theme.table.tableBgColor})`}),
      linear-gradient(
        to right,
        rgba(${`var(--gameday-table-tableBgColor, ${theme.table.tableBgColor})`}, 0.1),
        rgba(255, 255, 255, 0)
      ),
      linear-gradient(
        to left,
        rgba(${`var(--gameday-table-tableBgColor, ${theme.table.tableBgColor})`}, 0.1),
        rgba(255, 255, 255, 0)
      )
    `,
    backgroundPosition: `
      left center, right center,
      left center, right center;
      background-repeat: no-repeat;
      background-size: 20px 100%, 20px 100%, 5px 100%, 5px 100%;
      background-attachment: local, local, scroll, scroll;
    `,
    '&.no-padding': {
      paddingBottom: 0,
      marginBottom: 0,
    },
    '&.table-loading': {
      display: 'flex',
      justifyContent: 'center',
    },
    '& table': {
      maxWidth: 'none',
    },
    '&.row-actions': {
      '& th:last-child, td:last-child': {
        padding: 0,
        positon: 'sticky',
        right: 0,
        boxShadow: '-2px 0px 2px 0px rgba(0, 0, 0, 0.1)',
        '&::before': {
          content: '""',
          backgroundColor: '#e0e0e0',
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: '1px',
        },
        '& > div': {
          backgroundColor: theme.colors.white,
          padding: '10px 6px',
        },
      },
      '& th:last-child': {
        textAlign: 'right',
        boxShadow: '-2px 0px 2px 0px rgba(0, 0, 0, 0.1)',
      },
      '& tr:last-child': {
        overflow: 'none',
        '& td:last-child': {
          textAlign: 'right',
          boxShadow: '-2px 0px 2px 0px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    '&:first-child': {
      marginTop: 20,
    },
    '&.no-scroll': {
      '& th:last-child, td:last-child': {
        boxShadow: 'none !important',
      },
    },
  },
  table: {
    width: '100%',
    maxWidth: '100%',
    marginBottom: '20px',
    color: `var(--gameday-table-tableTextColor, ${theme.table.tableTextColor})`,
    fontSize: theme.typography.fontSizeSm,
    fontWeight: theme.typography.fontWeightBolder,
    borderCollapse: 'separate',
    borderSpacing: 'unset',
    '& .groupChild + .groupHeader td, & .groupChild + .groupHeader th': {
      borderTop: `12px solid ${`var(--gameday-table-tableHeaderRowBgColor, ${theme.table.tableHeaderRowBgColor})`}`,
    },
    '& .groupChild + .groupHeader td, & .groupChild + .groupHeader th, & .groupHeader + .groupHeader td, & .groupHeader + .groupHeader th, & .groupHeader + .tableRow:not(.groupChild) td':
      {
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          right: 0,
          left: 0,
          width: '100%',
          height: 1,
          backgroundColor: `var(--gameday-table-tableBorderColor, ${theme.table.tableBorderColor})`,
        },
      },
    '& .groupChild + .tableRow:not(.groupChild) td': {
      borderTop: `12px solid ${`var(--gameday-table-tableHeaderRowBgColor, ${theme.table.tableHeaderRowBgColor})`}`,
    },
    '& .groupChild td.isGroupChild': {
      position: 'relative',
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        right: 0,
        left: 0,
        height: 1,
        backgroundColor: `var(--gameday-table-tableBorderColor, ${theme.table.tableBorderColor})`,
      },
    },
    '& .groupHeader + .groupChild td.draggableCell': {
      borderTop: `1px solid ${`var(--gameday-table-tableHeaderRowBgColor, ${theme.table.tableHeaderRowBgColor})`}`,
    },
    '& .groupChild td:last-child': {
      paddingRight: 24,
    },
    '& .groupChild:last-child td': {
      borderBottom: `12px solid ${`var(--gameday-table-tableHeaderRowBgColor, ${theme.table.tableHeaderRowBgColor})`}`,
    },
    '& a:not(.MuiButton-root)': {
      color: `${theme.anchor.color}`,
      transition: 'color 0.1s linear',
      textDecoration: 'none',
      '&:hover': {
        color: `${theme.anchor.hoverColor}`,
        textDecoration: 'underline',
      },
    },
    '& label': {
      marginBottom: 0,
    },
    '&:has(.row-action)': {
      '& th:last-child': {
        position: 'sticky',
        right: 0,
        boxShadow: `-1px 1px 5px 0px ${`var(--gameday-mainNav-toggleColor, ${theme.mainNav.toggleColor})`}`,
      },
    },
  },
  loadingRow: {
    borderBottom: `1px solid ${`var(--gameday-table-tableBorderColor, ${theme.table.tableBorderColor})`}`,
  },
  loadingCell: {
    padding: '10px 6px',
  },
  skeleton: {
    margin: 0,
  },
  mobileHeader: {
    width: '100%',
  },
  mobileTools: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '8px',
    '& .filters-active': {
      color: theme.inputField.inputBorderActive,
    },
    '& $tableButtons.smallView': {
      flexDirection: 'column',
      '& div': {
        padding: '0 !important',
      },
      '& button': {
        width: '100%',
      },
      '& div:not(:last-child) button': {
        marginBottom: '8px',
      },
    },
  },
  mobileFilters: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    position: 'relative',
    marginBottom: '16px',
    padding: '16px 32px',
    backgroundColor: `var(--gameday-inputField-inputBGHover, ${theme.inputField.inputBGHover})`,
    '& > div > *': {
      margin: '0 8px 8px 0',
      '&:last-child': {
        marginBottom: '0',
      },
    },
  },
  filterContainer: {
    marginLeft: '-30px',
    marginRight: '-30px',
  },
  filterWrapper: {
    display: 'flex',
    flexDirection: 'column',
    '& > div:first-child': {
      position: 'relative',
      width: '100%',
      height: '10px',
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        right: '92px',
        width: 0,
        height: 0,
        borderLeft: '10px solid transparent',
        borderRight: '10px solid transparent',
        borderBottom: `10px solid ${`var(--gameday-inputField-inputBGHover, ${theme.inputField.inputBGHover})`}`,
      },
    },
  },
  topArrow: {},
  mobileSearch: {
    width: '100%',
  },
  extraFiltersWrap: {
    display: 'flex',
    width: '100%',
    marginBottom: '20px',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    '& > *': {
      margin: '0 4px',
    },
    '& > *:first-child': {
      marginLeft: 0,
    },
    '& > *:last-child': {
      marginRight: 0,
    },
  },
  rowHidden: {
    display: 'none',
    maxHeight: 0,
  },
  productModal: {
    paddingBottom: 30,
  },
  dragging: {
    display: 'table',
    border: '1px solid #ccc',
    borderCollapse: 'separate',
    borderRadius: '4px',
    background: 'rgba(255,255,255,0.7)',
    boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.2)',
    '& td': {
      borderBottom: 'none !important',
    },
  },
  selectedCount: {
    marginTop: '-10px',
    paddingLeft: '10px',
    paddingBottom: '5px',
  },
})

export default styles
